import { Heart, Home, Users, Flower2, Sun, TreePine, Clock, Utensils, Pill, Wrench, Shield, Car } from 'lucide-react';
import './SeniorLivingSection.css';

const SeniorLivingSection = () => {
    return (
        <section id="property" className="senior-living-section">
            {/* Decorative nature elements */}
            <div className="nature-decoration leaf-1">🍃</div>
            <div className="nature-decoration leaf-2">🍃</div>
            <div className="nature-decoration flower-1">🌸</div>
            <div className="nature-decoration flower-2">🌺</div>

            <div className="senior-living-container">
                {/* Hero Content */}
                <div className="senior-hero-content">
                    <div className="senior-badge">
                        <Heart size={16} />
                        <span>Assisted Living Community</span>
                    </div>

                    <h2 className="senior-title">
                        Welcome to<br />
                        <span className="highlight">Hollywood Royale Garden</span>
                    </h2>

                    <p className="senior-description">
                        An assisted living community designed to create opportunities for residents
                        to feel at home, surrounded by familiar spaces and staff who will support
                        personal needs. We offer both private and shared rooms including lovely
                        patios and balconies.
                    </p>

                    <div className="senior-features-list">
                        <div className="senior-feature-item">
                            <div className="feature-bullet">
                                <Home size={24} />
                            </div>
                            <div className="feature-text-content">
                                <h3 className="feature-inline-title">Feel at Home</h3>
                                <span className="feature-inline-desc"> - Familiar, comfortable spaces designed for your wellbeing</span>
                            </div>
                        </div>

                        <div className="senior-feature-item">
                            <div className="feature-bullet">
                                <Users size={24} />
                            </div>
                            <div className="feature-text-content">
                                <h3 className="feature-inline-title">Personal Care</h3>
                                <span className="feature-inline-desc"> - Dedicated staff supporting your individual needs</span>
                            </div>
                        </div>

                        <div className="senior-feature-item">
                            <div className="feature-bullet">
                                <Flower2 size={24} />
                            </div>
                            <div className="feature-text-content">
                                <h3 className="feature-inline-title">Beautiful Gardens</h3>
                                <span className="feature-inline-desc"> - Lovely patios and balconies with nature views</span>
                            </div>
                        </div>

                        <div className="senior-feature-item">
                            <div className="feature-bullet">
                                <Sun size={24} />
                            </div>
                            <div className="feature-text-content">
                                <h3 className="feature-inline-title">Bright Spaces</h3>
                                <span className="feature-inline-desc"> - Private and shared rooms filled with natural light</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Comprehensive Care Services Section - Modern Design */}
                <div id="amenities" className="care-services-section">
                    <div className="care-services-header">
                        <div className="header-badge">
                            <Heart size={18} className="badge-icon" />
                            <span>Excellence in Care</span>
                        </div>
                        <h3 className="care-services-title">
                            Comprehensive Care Services
                        </h3>
                        <p className="care-services-subtitle">
                            Dedicated support designed around your unique needs and preferences
                        </p>
                        <div className="title-underline">
                            <span className="underline-dot"></span>
                            <span className="underline-line"></span>
                            <span className="underline-dot"></span>
                        </div>
                    </div>

                    <div className="care-services-list">
                        <div className="senior-feature-item">
                            <div className="feature-bullet">
                                <Clock size={24} />
                            </div>
                            <div className="feature-text-content">
                                <h3 className="feature-inline-title">Personalized Care</h3>
                                <span className="feature-inline-desc"> - 24 hour personalized care planning to meet the unique needs of each resident</span>
                            </div>
                        </div>

                        <div className="senior-feature-item">
                            <div className="feature-bullet">
                                <Utensils size={24} />
                            </div>
                            <div className="feature-text-content">
                                <h3 className="feature-inline-title">Nutritious Meals</h3>
                                <span className="feature-inline-desc"> - Homestyle meals and snacks designed to support nutritional needs and cultural preferences</span>
                            </div>
                        </div>

                        <div className="senior-feature-item">
                            <div className="feature-bullet">
                                <Pill size={24} />
                            </div>
                            <div className="feature-text-content">
                                <h3 className="feature-inline-title">Medication Management</h3>
                                <span className="feature-inline-desc"> - Centrally stored and dispensed medication management, promoting health and wellbeing</span>
                            </div>
                        </div>

                        <div className="senior-feature-item">
                            <div className="feature-bullet">
                                <Wrench size={24} />
                            </div>
                            <div className="feature-text-content">
                                <h3 className="feature-inline-title">Maintenance & Housekeeping</h3>
                                <span className="feature-inline-desc"> - Professional housekeeping and maintenance services to keep your living space comfortable</span>
                            </div>
                        </div>

                        <div className="senior-feature-item">
                            <div className="feature-bullet">
                                <Car size={24} />
                            </div>
                            <div className="feature-text-content">
                                <h3 className="feature-inline-title">Transportation</h3>
                                <span className="feature-inline-desc"> - We will assist with coordinating transportation to doctor appointments and other health care needs</span>
                            </div>
                        </div>

                        <div className="senior-feature-item">
                            <div className="feature-bullet">
                                <Shield size={24} />
                            </div>
                            <div className="feature-text-content">
                                <h3 className="feature-inline-title">Safety & Security</h3>
                                <span className="feature-inline-desc"> - In addition to 24/7 staffing, we have technology and systems that promote safety and security</span>
                            </div>
                        </div>
                    </div>

                    {/* Stats Banner */}
                    <div className="care-stats-banner">
                        <div className="stat-item">
                            <div className="stat-number">24/7</div>
                            <div className="stat-label">Care Available</div>
                        </div>
                        <div className="stat-divider"></div>
                        <div className="stat-item">
                            <div className="stat-number">100%</div>
                            <div className="stat-label">Personalized Plans</div>
                        </div>
                        <div className="stat-divider"></div>
                        <div className="stat-item">
                            <div className="stat-number">Expert</div>
                            <div className="stat-label">Professional Staff</div>
                        </div>
                    </div>
                </div>



            </div>
        </section>
    );
};

export default SeniorLivingSection;
